import { useCallback } from 'react';

import { useLocation, useNavigate } from '@xing-com/crate-core-router';
import { useLoginAppUrl } from '@xing-com/crate-xinglet';

type RedirectToLoginFunction = () => void;

export const useRedirectToLoginWithDestinationUrl =
  (): RedirectToLoginFunction => {
    const location = useLocation();
    const navigate = useNavigate();
    const loginAppUrl = useLoginAppUrl();
    const loginPath = `${loginAppUrl}?dest_url=${encodeURIComponent(location.pathname)}`;

    return useCallback(() => {
      navigate(loginPath);
    }, [navigate, loginPath]);
  };
